import * as React from 'react';
import { cva } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const pageContentVariants = cva('w-full flex items-start justify-between gap-y-[60px] gap-x-[120px] 2xl:gap-x-[240px]', {
  variants: {
    variant: {
      default: 'flex-wrap',
      'wrap-reverse': 'flex-wrap-reverse',
      fill: 'flex-wrap items-stretch flex-grow'
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});

const PageContent = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    id="page-content"
    className={cn(pageContentVariants({ variant }), className)}
    {...props}
  />
));
PageContent.displayName = 'PageContent';

const pageColVariants = cva('flex-grow basis-0 min-w-[300px] max-w-full', {
  variants: {
    variant: {
      default: 'flex flex-col gap-5'
    },
    bg: {
      true: 'bg-white shadow-dropshadow-sm py-5 px-8 rounded-xl'
    }
  },
  defaultVariants: {
    variant: 'default',
    bg: false
  }
});

const PageCol = React.forwardRef(({ className, variant, bg, ...props }, ref) => (
  <div
    ref={ref}
    id="page-col"
    className={cn(pageColVariants({ variant, bg }), className)}
    {...props}
  />
));
PageCol.displayName = 'PageCol';

const pageSidebarVariants = cva('w-full max-w-full flex flex-col', {
  variants: {
    variant: {
      default: 'lg:w-[240px] 2xl:w-[344px]',
      md: 'lg:w-[320px] 2xl:w-[344px]',
      chat: 'lg:w-[344px]',
      sticky: 'sticky top-0',
      calendar: 'lg:w-64'
    },
    overflow: {
      true: 'overflow-y-auto overflow-x-hidden',
      false: ''
    },
    bg: {
      true: 'bg-white shadow-dropshadow-sm rounded-[10px] p-5',
      false: ''
    },
    forum: {
      true: 'lg:max-h-[calc(100vh-120px)] px-2'
    }
  },
  defaultVariants: {
    variant: 'default',
    overflow: true,
    bg: false,
    forum: false
  }
});

const PageSidebar = React.forwardRef(({ className, variant, overflow, bg, forum, ...props }, ref) => (
  <aside
    ref={ref}
    id="page-sidebar"
    className={cn(pageSidebarVariants({ variant, overflow, bg, forum }), className)}
    {...props}
  />
));
PageSidebar.displayName = 'PageSidebar';

const PageSidebarTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn(
      'page-sidebar-title',
      // Estilo base
      'mb-6 inline-block self-start rounded border border-solid border-neutral-lightest px-3 py-1 text-sm font-light text-primary-dark',
      className
    )}
    {...props}
  />
));
PageSidebarTitle.displayName = 'PageSidebarTitle';

export { PageContent, PageCol, PageSidebar, PageSidebarTitle };
